import { Kudos } from "./Kudos";
import { z } from "zod";

export const KudosList = z.object({
  kudos: Kudos.array().default([]),
  last_page: z.boolean(),
});

export type KudosList = z.infer<typeof KudosList>;
